enum CampaignStep {
  Home = 'Home',
  Brief = 'Brief',
  Placements = 'Placements',
  Trackers = 'Trackers',
  ConceptPlan = 'ConceptPlan',
  CampaignLogic = 'CampaignLogic',
  AdsVariations = 'Ads',
  Tearsheet = 'Tearsheet',
  TearsheetPreview = 'TearsheetPreview',
  Insights = 'Insights',
  AdVariationAnalysis = 'AdVariationAnalysis',
}

enum CampaignPagePublic {
  PublicCampaignLogic = 'PublicCampaignLogic',
  PublicConceptPlan = 'PublicConceptPlan',
  PublicCampaignAds = 'PublicCampaignAds',
}

enum CampaignStepApprovalStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'PendingApproval',
  InProgress = 'InProgress',
}

enum CampaignStepApprovalStatusOption {
  SubmitForApproval = 'Submit for Approval',
  Approve = 'Approve',
  BackToEdit = 'Back To Edit',
  BackToApproval = 'Back To Approval',
}

type CampaignStepWithComments =
  | CampaignStep.CampaignLogic
  | CampaignStep.ConceptPlan
  | CampaignStep.Tearsheet;

type CampaignStepWithIssues =
  | CampaignStep.CampaignLogic
  | CampaignStep.Placements
  | CampaignStep.Trackers
  | CampaignStep.AdsVariations
  | CampaignStep.Home;

export {
  CampaignStep,
  CampaignStepWithIssues,
  CampaignStepApprovalStatus,
  CampaignStepWithComments,
  CampaignStepApprovalStatusOption,
  CampaignPagePublic,
};
